module.exports = __webpack_public_path__ + "static/feature1-0c53187c30a7fbef2c4a8dff7eeebee1.png";